'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Personal;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Personal(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-personal ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { fill: 'none', fillRule: 'evenodd' },
      _react2.default.createElement('path', { fill: color, d: 'M6,11 L10,11 C12.209139,11 14,12.790861 14,15 L2,15 L2,15 C2,12.790861 3.790861,11 6,11 Z' }),
      _react2.default.createElement('circle', { cx: '8', cy: '6', r: '4', fill: color })
    )
  );
}

Personal.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Personal/Personal.js
// module id = 297
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16